function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useState } from 'react';
import { Button, Divider, Drawer, Flex, MultiCombobox, MultiSelect, Select, createForm } from '@applyboard/crystal-ui';
import { ToggleOutlineIcon } from '@applyboard/ui-icons';
import { useEventTracker } from '@applyboard/ui-utils';
import { filterMultiplePropertiesOptions } from "../../data/tasks";
import { formatIntake } from "../../utils/taskUtils";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var _createForm = createForm(),
  Form = _createForm.Form,
  Field = _createForm.Field,
  useResetForm = _createForm.useResetForm;
export function TasksFilterDrawer(_ref) {
  var onFilterSubmit = _ref.onFilterSubmit,
    resetFilter = _ref.resetFilter,
    filterOptions = _ref.filterOptions,
    filterValues = _ref.filterValues;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    openDrawer = _useState2[0],
    setOpenDrawer = _useState2[1];
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var appStages = filterOptions.appStages,
    uniqueApplicationIds = filterOptions.uniqueApplicationIds,
    uniqueAssignees = filterOptions.uniqueAssignees,
    uniqueIntakes = filterOptions.uniqueIntakes,
    uniqueSchoolCountries = filterOptions.uniqueSchoolCountries,
    uniqueSchoolNames = filterOptions.uniqueSchoolNames,
    uniqueStudents = filterOptions.uniqueStudents;
  return _jsx(_Fragment, {
    children: _jsxs(Drawer, {
      open: openDrawer,
      onOpenChange: setOpenDrawer,
      placement: "right",
      children: [_jsx(Drawer.Trigger, {
        children: _jsx(Button, {
          intent: "primary",
          leadIcon: ToggleOutlineIcon,
          onClick: function onClick() {
            return setOpenDrawer(true);
          },
          width: "fill",
          children: "Filter"
        })
      }), _jsx(Drawer.Header, {
        children: "All filters"
      }), _jsxs(Form, {
        defaultValues: filterValues,
        onSubmit: function onSubmit(data) {
          onFilterSubmit(data);
          setOpenDrawer(false);
          trackEvent({
            event: 'Task Management v2 - Clicked To Apply Filters',
            data: _objectSpread({}, data)
          });
        },
        children: [_jsxs(Flex, {
          direction: "column",
          gap: 4,
          children: [_jsx(Field, {
            name: "intakes",
            as: MultiSelect,
            label: "Intake",
            placeholder: "Select",
            children: uniqueIntakes.map(function (intake) {
              return _jsx(MultiSelect.Option, {
                label: formatIntake(intake),
                value: intake
              }, intake);
            })
          }), _jsx(Field, {
            "aria-label": "Application ID",
            as: MultiCombobox,
            filterOption: function filterOption(option, query) {
              return option.label.toLowerCase().includes(query.trim().toLowerCase());
            },
            label: "Application ID",
            name: "applicationIds",
            placeholder: "Type application number...",
            placeholderVariant: "indicator",
            children: uniqueApplicationIds.map(function (appId) {
              return _jsx(MultiCombobox.Option, {
                value: appId,
                label: appId
              }, appId);
            })
          }), _jsx(Field, {
            "aria-label": "Student",
            as: MultiCombobox,
            filterOption: function filterOption(option, query) {
              return filterMultiplePropertiesOptions(uniqueStudents, query, option.label);
            },
            label: "Student",
            name: "students",
            placeholder: "Type student name, email or ID...",
            placeholderVariant: "indicator",
            children: uniqueStudents.map(function (student) {
              return _jsx(MultiCombobox.Option, {
                value: student.name,
                label: student.name
              }, student.name);
            })
          }), _jsx(Field, {
            "aria-label": "School name",
            as: MultiCombobox,
            filterOption: function filterOption(option, query) {
              return option.label.toLowerCase().includes(query.trim().toLowerCase());
            },
            label: "School name",
            name: "schoolNames",
            placeholder: "Type school name...",
            placeholderVariant: "indicator",
            children: uniqueSchoolNames.map(function (schoolName) {
              return _jsx(MultiCombobox.Option, {
                value: schoolName,
                label: schoolName
              }, schoolName);
            })
          }), _jsx(Field, {
            "aria-label": "Assignee",
            as: MultiCombobox,
            filterOption: function filterOption(option, query) {
              return filterMultiplePropertiesOptions(uniqueAssignees, query, option.label);
            },
            label: "Assignee",
            name: "assignees",
            placeholder: "Type assignee name, email or ID...",
            placeholderVariant: "indicator",
            children: uniqueAssignees.map(function (assignee) {
              return _jsx(MultiCombobox.Option, {
                value: assignee.name,
                label: assignee.name
              }, assignee.name);
            })
          }), _jsx(Field, {
            name: "schoolCountries",
            as: MultiSelect,
            label: "School country",
            placeholder: "Select",
            children: uniqueSchoolCountries.map(function (schoolCountry) {
              return _jsx(MultiSelect.Option, {
                value: schoolCountry,
                label: schoolCountry
              }, schoolCountry);
            })
          }), _jsxs(Field, {
            name: "dueDate",
            as: Select,
            label: "Due date",
            placeholder: "Select",
            appearance: "styled",
            children: [_jsx(Select.Option, {
              label: "1-2 days left",
              value: "1-2"
            }), _jsx(Select.Option, {
              label: "2-14 days left",
              value: "2-14"
            }), _jsx(Select.Option, {
              label: "2 weeks or more left",
              value: "14+"
            }), _jsx(Select.Option, {
              label: "Past due/Overdue",
              value: "pastDue"
            })]
          }), _jsx(Field, {
            name: "appStage",
            as: MultiSelect,
            label: "Application stage",
            placeholderVariant: "indicator",
            children: appStages.map(function (appStage) {
              return _jsx(MultiSelect.Option, {
                label: appStage.charAt(0).toUpperCase() + appStage.slice(1),
                value: appStage
              }, appStage);
            })
          })]
        }), _jsx(Divider, {}), _jsxs(Flex, {
          align: "center",
          justify: "end",
          gap: 2,
          children: [_jsx(ResetButton, {
            setOpenDrawer: setOpenDrawer,
            resetFilter: resetFilter
          }), _jsx(Button, {
            intent: "primary",
            type: "submit",
            width: "hug",
            children: "Apply"
          })]
        })]
      })]
    })
  });
}
function ResetButton(_ref2) {
  var setOpenDrawer = _ref2.setOpenDrawer,
    resetFilter = _ref2.resetFilter;
  var resetForm = useResetForm();
  var _useEventTracker2 = useEventTracker(),
    trackEvent = _useEventTracker2.trackEvent;
  function onClearAll() {
    resetFilter();
    resetForm();
    setOpenDrawer(false);
    trackEvent({
      event: 'Task Management v2 - Clicked Clear All Filters'
    });
  }
  return _jsx(Button, {
    onClick: onClearAll,
    emphasis: "highlighted",
    width: "hug",
    children: "Clear all"
  });
}